module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center-panel md-scrollbar md-theme-default",
    attrs: {
      "id": "users"
    }
  }, [_c('md-content', {
    staticClass: "md-elevation-1",
    attrs: {
      "md-theme": "white"
    }
  }, [_c('user-menu'), _c('div', {
    staticClass: "md-flex",
    attrs: {
      "md-theme": "white"
    }
  }, [(_vm.modules && _vm.modules.length) ? _c('md-table', {
    attrs: {
      "md-theme": "white"
    }
  }, _vm._l((_vm.modules), function(module, key) {
    return _c('router-link', {
      key: module.id,
      staticClass: "md-table-row link",
      attrs: {
        "tag": "tr",
        "to": {
          name: 'UserModuleActions',
          params: {
            code: module.code
          },
          query: _vm.$route.query
        }
      }
    }, [_c('md-table-cell', {
      staticClass: "name"
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s(module.description))])])]), _c('md-table-cell', {
      staticClass: "load right"
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s((module.load) ? 'Загружен' : 'Не загружен'))])])]), _c('md-table-cell', {
      staticClass: "active right"
    }, [_c('span', {
      staticClass: "md-layout-row md-gutter"
    }, [_c('span', {
      staticClass: "md-flex name"
    }, [_vm._v(_vm._s((module.active) ? 'Активен' : 'Не активен'))])])])], 1)
  })) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f1e06080","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/users/views/Modules.vue
// module id = 1277
// module chunks = 0